<template>
  <div class="book">
    <div class="coverInfo">
      <img class="coverImage" src="//textcafe.co/books/YQ6Xvp/tc-custom/9783988261939.jpg?1704424706213" alt="This image is the cover for the book An Inland Voyage, Classics To Go"/>
    </div>
    <div class="bookInfo">
      <h1 class="bookTitle heading font1">An Inland Voyage, Classics To Go
      </h1>
      <p class="bookDescription body article font2">
        <p>An Inland Voyage is a travelogue by Robert Louis Stevenson about a canoeing trip through France and Belgium in 1876. It is Stevenson's earliest book and a pioneering work of outdoor literature.</p>
      </p>
    </div>
    <div class="authorInfo">
      <h2 class="authorName heading font1">
        Robert Louis Stevenson
      </h2>
      
      <p class="authorDescription body article">Robert Louis Stevenson (13 November 1850 - 3 December 1894) was a Scottish novelist, poet, and travel writer. Born in Edinburgh, Scotland, he was a sickly child, but he grew up to become one of the most famous and widely-read authors of his time. He is best known for his adventure novels, such as "Treasure Island" (1883) and "Kidnapped" (1886), as well as his novel "The Strange Case of Dr. Jekyll and Mr. Hyde" (1886), a chilling tale of a man who transforms into a monster. In addition to his writing, Stevenson was an avid traveler, visiting the United States, Europe, and the Pacific islands. He eventually settled in Samoa, where he died of a stroke at the age of 44. Despite his short life, he left behind a lasting legacy, and his works continue to be popular and widely read today.</p>
      
      
    </div>
    <div class="publisherInfo">
     <h2 class="publisherName heading font1">
      OTB ebook
     </h2>
        
        
     
    </div>
  </div>
</template>

<script>
// import Navigation from '@/components/Navigation'
export default {
  name: 'home',
  data() {
    return {}
  },
  components: {
    // 'navigation': Navigation
  }
}
</script>


// WEBPACK FOOTER //
// home.vue?7cbe0f67